/*  File name: syros.tsx
    Author name: Marcello Nunes Bernardes
    Website name: https://comp2112-final-marcellobernardes.onrender.com/
    File Description: Component page
*/


import React from 'react';
import SyrosImg from '../../Assets/images/syros.jpg';

function Syros ()
{

    return(

<div className="container">
        <article id="Syros" className="row">
            <h2 className="col-md-10 col-xs-offset-1 col-xs-10">Syros</h2>
            <img className="col-md-10 col-xs-offset-1 col-xs-10" src={SyrosImg} alt="Syros" />
            <p className="col-md-10 col-xs-offset-1 col-xs-10" id="Syros">
                A favourite Athenian escape and former shipowners' vacation spot full of grand mansions, Syros is little known to foreigners. Famous for its neoclassNameical architecture and perfectly preserved heritage, its capital, Ermoupolis, was a 13th-century Venetian-built town and important trade and industrial centre, and boasts giant churches and beautiful villas, a stunning town hall, and labyrinthine streets and stairways.
            </p>
        </article>
        <hr />
    </div>

    );
}

export  default Syros;